import { Component, Input, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ExtraInfo } from 'src/app/core/models/order';
import { OrderService } from 'src/app/core/services/order.service';
import { OrderPreviewData } from '../../order-preview.component';
// import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';

@Component({
  selector: 'app-extra-info',
  templateUrl: './extra-info.component.html',
  styleUrls: ['./extra-info.component.scss'],
})
export class ExtraInfoComponent implements OnInit {
  @Input({ required: true }) data!: OrderPreviewData;
  text?: string;

  constructor(
    private orderService: OrderService,
    // private keyboard: Keyboard,
  ) {
  }

  ngOnInit(): void {
    this.text = this.data.order.client.extraInfo;
  }

  save() {
    // if(this.keyboard.isVisible) {
    //   this.keyboard.hide();
    // }

    let info: ExtraInfo = {
      orderId: this.data.order.id,
      extraInfo: this.text ? this.text : this.data.order.client.extraInfo,
      oneTimeExtraInfo: this.data.order.client.oneTimeExtraInfo,
      internalInfo: this.data.order.client.internalInfo
    }

    this.orderService.addNote(info)
      .pipe(
        switchMap(
          () => this.orderService.refreshOrders()
        )).subscribe();
  }
}
